import { render, staticRenderFns } from "./TopluIslerView.vue?vue&type=template&id=28ff2a8f&scoped=true"
import script from "./TopluIslerView.vue?vue&type=script&lang=ts"
export * from "./TopluIslerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff2a8f",
  null
  
)

export default component.exports